import theAxios from 'axios'

const axios = theAxios.create({
    baseURL:'https://www.0452jj.top',  // 接口公共请求地址
    timeout:20000						// 服务器在20000毫秒内没有给出反馈，就是无效反馈
})

// 一次请求  一次反馈
export default({url,method='get',params={},data={},header={}})=>{
    return axios({
        url,
        method,
        params,
        data,
        header
    })
}